import { ISystemConfig } from '../../definitions/MiscSchema'
import ApiUrlCompiler from '../api_urls/ApiUrlCompiler'
import API_URLS from '../ApiUrls'
import HttpClient from '../HttpClient'

class FiltersApiClientClass {
    getProvidersFilter = async (contractId?: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getProvidersFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getClaimStatusFilter = async (contractId: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getClaimStatusFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getPatientsFilter = async (contractId?: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getPatientsFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getICD10CodeFilter = async (contractId?: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getICD10CodeFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getMembersFilter = async (contractId?: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getMembersFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getQualityMeasuresFilter = async (contractId?: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getQualityMeasuresFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getFundsFilter = async (contractId: number): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getFundsFilter)
        const body = { contractId }

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getContractsFilter = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getContractsFilter)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getLineOfBusiness = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getLineOfBusiness)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getContractType = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getContractType)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getFundingStrategies = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getFundingStrategies)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getContractStatuses = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getContractStatuses)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getTaskStatuses = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getTaskStatuses)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getArrangementTypes = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getArrangementTypes)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getFeeCostBases = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getFeeCostBases)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getContingencyCostBases = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getContingencyCostBases)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getSharedCostBases = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getSharedCostBases)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }

    getBusinessSegments = async (): Promise<ISystemConfig[]> => {
        const { url, headers } = ApiUrlCompiler.compile(API_URLS.os.getBusinessSegments)
        const body = {}

        return await HttpClient.post<ISystemConfig[]>(url, body, headers)
    }
}

const FiltersApiClient = new FiltersApiClientClass()
export default FiltersApiClient
